import { defineStore } from 'pinia'

import type { PromocodesStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const usePromocodesStore = defineStore('promocodes', {
  state: (): PromocodesStore => ({
    loading: false,
    saving: false,
    promocodes: [],
    meta: null,
    discounts: [],
    filterSearch: null,
    filterStatus: null,
    filterDiscount: null,
    filterFrom: null,
    filterTo: null,
    currentPage: 1,
    perPage: 25,
    isModalCreate: false,
    promocodeToEdit: null,
  }),
  actions,
  getters,
})
